import React, {
  useState,
  useEffect,
  useRef
} from 'react';

import PropTypes from 'prop-types';

import {
  UpDownArrowsNew,
  ArrowIcon
} from '../Svg';

import './FilterDropDown.css';

const FilterDropDown = (props) => {

  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);

  const [ showptions, setShowoptions ] = useState(false);

  const updateSelectedOption = (option) => {
    setShowoptions(!showptions);
    props.updateSelectedOption(option);
  };

  function useOutsideAlerter(ref) {
    useEffect(() => {

      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setShowoptions(false);
        }
      }

      document.addEventListener('mousedown', handleClickOutside);

      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }, [ ref ]);
  }

  return (
    <div ref={wrapperRef} className='filter-dropdown-container'>

      <div className={showptions ? 'filter-dropdown-select-wrapper-open' : 'filter-dropdown-select-wrapper'}>

        <div
          className="filter-dropdown-option-container"
          onClick={() => setShowoptions(!showptions)}>

          <div className='filter-icon'><UpDownArrowsNew/></div>

          <p className={`filter-current-option ${ props.selectedValue ? 'filter-vodafoneBold' : '' }`}>
            {
              props.selectedValue ? props.selectedValue : ''
            }
          </p>

          <p className='filter-current-option'>
            <ArrowIcon
              direction={showptions ? 'icon-chevron-up' : 'icon-chevron-down'}
            />
          </p>
        </div>
      </div>

      {
        showptions ?
          <div className="filter-all-options" >
            {
              props.options && props.options.map((option, index) => {
                return (
                  <p
                    key={index}
                    className="filter-single-option"
                    onClick={() => updateSelectedOption(option)}
                  >
                    {option}
                  </p>
                );
              })
            }
          </div>
          :
          null
      }
    </div>
  );
};

FilterDropDown.propTypes = {
  automationidattr: PropTypes.string,
  options: PropTypes.arrayOf(PropTypes.string),
  placeHolder: PropTypes.string,
  selectedValue: PropTypes.string,
  updateSelectedOption: PropTypes.func.isRequired
};

export default FilterDropDown;